module.exports = __webpack_public_path__ + "img/new.308c5c74.png";